var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useContext, useState } from "react";
import useWindowSize from "react-use/lib/useWindowSize";
import { PopperZIndexProvider } from "../../../../misc/scroller/PopperZIndexProvider";
import { CheckboxCol, RenderStringCol, StringCol, Table, useTableRefreshAll, ViewOnly } from "../../../../misc/scroller/Table";
import { api } from "../../../../api/API";
import { forcesByOthers, prefixedName } from "../../../../api/SupplierCategories";
import { useProjectId } from "../ProjectName";
import { useAlternative } from "../../quote/alternative/Alternative";
import { ChangePreviewContext } from "../ShopDrawingChangePreview";
import { blue } from "@mui/material/colors";
import { useSupplierCategories } from "./SupplierContext";
import { useSnackbar } from "../../../../misc/Snackbar";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const tableName = "project.supplier-categories.manage";
export function ManageProjectSuppliers(props) {
    const win = useWindowSize();
    const project = useProjectId();
    const alternative = useAlternative();
    const previewChangeset = useContext(ChangePreviewContext);
    const previewId = previewChangeset.enabled ? previewChangeset.sessionId : undefined; // openings tables resolve each row's by-others from the supplier by-us setting, so a
    // change here must reload them. Deferred to close so the reload happens once.
    const suppliers = useSupplierCategories();
    const refreshAll = useTableRefreshAll();
    const snack = useSnackbar();
    const [changed, setChanged] = useState(false); // reload the openings/hardware tables (and the supplier context they inherit from)
    // once, when the dialog closes, if anything changed.
    const close = () => { if (changed) {
        suppliers.reload();
        refreshAll();
    } props.onDone(); };
    return /*#__PURE__*/ _jsxs(Dialog, { open: true, onClose: close, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: "Edit Supplied Categories" }), /*#__PURE__*/ _jsx("div", { style: { minHeight: win.height * 0.5, minWidth: 400, display: "flex", flexDirection: "column", position: "relative" }, children: /*#__PURE__*/ _jsx(PopperZIndexProvider, { value: 1400, children: /*#__PURE__*/ _jsx(Table, { name: tableName, fetch: () => api.supplierCategories.listForProject({ project, alternative, previewChangeset: previewId }).then(rows => rows.map(row => forcesByOthers(row) ? Object.assign(Object.assign({}, row), { byUs: false }) : row)), fetchDeps: [project, alternative, previewId], cellCustomize: { backgroundColor: row => { if (row.backup && row.backup.byUs !== row.byUs) {
                                return blue["100"];
                            } } }, columns: [ViewOnly(RenderStringCol("Name", row => prefixedName(row), 200)), CheckboxCol("By Us", "byUs", 100, row => forcesByOthers(row)), StringCol("Note", "note", 250)], onChange: (row) => __awaiter(this, void 0, void 0, function* () {
                            // take a while; show a loading snack once it exceeds 250ms. The
                            // table's own success/error snack replaces it when we settle.
                            const loadingTimer = setTimeout(() => snack.loading("Updating supplied category..."), 250);
                            try {
                                const updated = yield api.supplierCategories.upsertForProject(row);
                                setChanged(true);
                                return updated;
                            }
                            finally {
                                clearTimeout(loadingTimer);
                            }
                        }) }) }) }), /*#__PURE__*/ _jsx(DialogActions, { children: /*#__PURE__*/ _jsx(Button, { onClick: close, children: "Close" }) })] });
}
